// @flow

import React from 'react';
import {injectIntl} from 'react-intl';
import {Button, FormGroup, Head} from '@xsolla/uikit';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import {compose} from 'recompose';
import style from './style.css';

const cx = classNames.bind(style);

type Props = {
  +intl: any,
  +isOpen: boolean,
  +transactionId: number,
  +partnerEvidence: {
    +response_text: string,
    +partner_files?: Array<{
      +id: string,
      +name: string
    }>
  },
  +onClose: () => void
};

const ViewSubmittedProof = ({intl, isOpen, transactionId, partnerEvidence, onClose}: Props) => {
  if (!isOpen) {
    return null;
  }

  const handleBackdropClick = event => {
    if (event.target === event.currentTarget) {
      onClose();
    }
  };

  return (
    <div className={cx('modal-backdrop')} onClick={handleBackdropClick}>
      <div className={cx('modal-panel')}>
        <div className={cx('view-proof-form')}>
          <div className={cx('view-proof-form__header')}>
            <Head>{intl.messages['app.support.disputes.proof-form.modal.title']}</Head>
            <Button appearance="flatten" size="sm" icon="close" onClick={onClose} />
          </div>

          <FormGroup
            label={intl.messages['app.support.disputes.proof-form.transaction-ids']}
            style={{marginBottom: '20px'}}>
            <input
              type="text"
              value={transactionId}
              readOnly={true}
              className={cx('view-proof-form__input')}
            />
          </FormGroup>

          <FormGroup
            label={intl.messages['app.support.disputes.proof-form.commentary.label']}
            style={{marginBottom: '20px'}}>
            <div className={cx('view-proof-form__commentary')}>
              {partnerEvidence?.response_text || ''}
            </div>
          </FormGroup>

          <FormGroup
            label={intl.messages['app.support.disputes.proof-form.uploaded-files.label']}
            style={{marginBottom: '20px'}}>
            {partnerEvidence?.partner_files && partnerEvidence.partner_files.length > 0 ? (
              <div className={cx('view-proof-form__files')}>
                {partnerEvidence.partner_files.map((file, index) => (
                  <div key={file.id || index} className={cx('view-proof-form__file-item')}>
                    <span className={cx('view-proof-form__file-name')}>{file.name}</span>
                  </div>
                ))}
              </div>
            ) : (
              <div className={cx('view-proof-form__no-files')}>
                {intl.messages['app.support.disputes.proof-form.no-files']}
              </div>
            )}
          </FormGroup>
        </div>
      </div>
    </div>
  );
};

ViewSubmittedProof.propTypes = {
  intl: PropTypes.object.isRequired,
  isOpen: PropTypes.bool.isRequired,
  transactionId: PropTypes.number.isRequired,
  partnerEvidence: PropTypes.object,
  onClose: PropTypes.func.isRequired
};

const enhance = compose(injectIntl);

export default enhance(ViewSubmittedProof);
